import _ from 'lodash';

export default function retrieveContactFromAr(assistanceRequest, requestor) {
  return _.get(assistanceRequest, 'contact', null) || _.get(assistanceRequest, 'converted_to[0].contact', requestor);
}
